import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tramites from './pages/Tramites';
import Administracion from './pages/Administracion';
import ConsultasReportes from './pages/ConsultasReportes';
import Mapas from './pages/Mapas';
import OCR from './pages/OCR';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/tramites/*" element={<Tramites />} />
                  <Route path="/administracion/*" element={<Administracion />} />
                  <Route path="/consultas-reportes/*" element={<ConsultasReportes />} />
                  <Route path="/mapas" element={<Mapas />} />
                  <Route path="/ocr" element={<OCR />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
